"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveItemDescriptions = exports.getItemDescription = exports.saveWarninglabels = exports.getWarningLabels = exports.updatepoinventoryandsiteinventory = exports.saveinventorysitelots = exports.updateinventorysitelots = exports.removeinventorysitelot = exports.updateinventorysitelotfrombarcode = exports.addinventorysitelot = exports.listinventorysitelots = exports.updateInventorySiteActive = exports.manualCreate = exports.removegroup = exports.enable = exports.getClaimUnresolved = exports.remove = exports.linkinventorytosite = exports.getsetidfrompkg = exports.savesitepriorities = exports.saveinventorysite = exports.savesites = exports.updateAllsite = exports.updatesite = exports.savegroupmapped = exports.savegroup = exports.save = exports.readActionlog = exports.read = exports.creategroup = exports.create = exports.listgroup = exports.list = exports.listallinventories = exports.fetchInventorySite = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.fetchInventorySite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    path: "inventory/fetchinventorysite"
});
exports.listallinventories = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    path: "inventory/listallinventories"
});
exports.list = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    path: "inventory/list"
});
exports.listgroup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    path: "inventory/listgroup"
});
exports.create = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/create"
});
exports.creategroup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/creategroup"
});
exports.read = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    tokens: { id: "number.required" },
    path: "inventory/read"
});
// E-086
exports.readActionlog = endpoint_1.createEndpoint()({
    method: "get",
    path: "actionlog/read",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    tokens: { id: "number.required" }
});
exports.save = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/save"
});
exports.savegroup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/savegroup"
});
exports.savegroupmapped = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/savegroupmapped"
});
exports.updatesite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/updatesite"
});
// for multiple checkbox selection // Active Formulary > Does not save update after select all  then deselect all C-046.182 25/07/2025
exports.updateAllsite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/updateAllsite"
});
exports.savesites = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_UPDATE,
    method: "put",
    path: "inventory/savesites"
});
exports.saveinventorysite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE,
    method: "put",
    path: "inventory/saveinventorysite"
});
exports.savesitepriorities = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE,
    method: "put",
    path: "inventory/savesitepriorities"
});
exports.getsetidfrompkg = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    method: "get",
    path: "inventory/getsetidfrompkg"
});
exports.linkinventorytosite = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE,
    method: "put",
    path: "inventory/linkinventorytosite"
});
exports.remove = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_DELETE,
    method: "delete",
    tokens: { id: "number.required" },
    path: "inventory/delete"
});
// C-046.10
exports.getClaimUnresolved = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_DELETE,
    method: "get",
    tokens: { id: "number.required" },
    path: "inventory/read-unresolved"
});
// C-046.11
exports.enable = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE,
    method: "put",
    tokens: { id: "number.required" },
    path: "inventory/enable"
});
exports.removegroup = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_DELETE,
    method: "delete",
    path: "inventory/delete"
});
exports.manualCreate = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/createManual"
});
exports.updateInventorySiteActive = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORYSITE_UPDATE,
    method: "put",
    path: "inventory/updateInventorySiteActive"
});
exports.listinventorysitelots = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "get",
    path: "inventory/listinventorysitelots"
});
exports.addinventorysitelot = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "post",
    path: "inventory/addinventorysitelot"
});
exports.updateinventorysitelotfrombarcode = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "post",
    path: "inventory/updateinventorysitelotfrombarcode"
});
exports.removeinventorysitelot = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "put",
    path: "inventory/removeinventorysitelot"
});
exports.updateinventorysitelots = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "put",
    path: "inventory/updateinventorysitelots"
});
exports.saveinventorysitelots = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "put",
    path: "inventory/saveinventorysitelots"
});
exports.updatepoinventoryandsiteinventory = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_READ,
    method: "put",
    path: "inventory/updatepoinventoryandsiteinventory"
});
exports.getWarningLabels = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/getWarningLabels"
});
exports.saveWarninglabels = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/saveWarningLabels"
});
exports.getItemDescription = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/getItemDescriptions"
});
exports.saveItemDescriptions = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_INVENTORY_CREATE,
    method: "post",
    path: "inventory/saveItemDescriptions"
});



//////////////////
// WEBPACK FOOTER
// ./src/api/inventory/inventory-client.ts
// module id = 987
// module chunks = 0 1 2